import { useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

function currentHistoryIndex(): number | null {
  const idx = window.history.state?.idx;
  return typeof idx === 'number' ? idx : null;
}

/**
 * The DOM exposes no "is there a forward entry" flag, so track it: react-router stamps an
 * incrementing `idx` on each history entry. A PUSH truncates everything ahead of it, so the
 * furthest entry we can reach forward is the highest idx seen since the last push.
 */
export function useCanGoForward(): boolean {
  useLocation();
  const navigationType = useNavigationType();
  const furthestIndex = useRef(0);

  const index = currentHistoryIndex();
  if (index === null) return false;

  furthestIndex.current = navigationType === 'PUSH' ? index : Math.max(furthestIndex.current, index);

  return index < furthestIndex.current;
}
